export default () => ({
	location: '',
	shops: [],
	default_quantity: 4,
	active_store: '',
	localization: '',

	async searhStores() {
		const url = `https://service.bklynsoap.com/shopfinder/?address=${this.location}`;

		const response = await fetch(url);
		if (response.status !== 200) return;

		const data = await response.json();

		if (data) {
			const shops = data.shops.filter((el) => el.city !== 'city');
			this.shops = shops;
		}
	},

	setActiveStore(store_id) {
		if (this.active_store !== store_id) {
			this.active_store = store_id;
		} else {
			this.active_store = '';
		}
	},

	getMapUrl(address, zip, city) {
		let current_address = `${address}, ${city}, ${zip} ${this.localization}`;
		let url = `https://maps.google.com/?q=${current_address}`;
		return url;
	},

	// Initialize and add the map

	async initMap(latitute, longtitude, id) {
		const position = { lat: Number(latitute), lng: Number(longtitude) };

		const { Map } = await google.maps.importLibrary('maps');
		const { AdvancedMarkerView } = await google.maps.importLibrary('marker');

		// The map, centered at Uluru
		let map = new Map(document.getElementById(`store-map-container-${id}`), {
			zoom: 18,
			center: position,
			mapId: id,
		});

		// The marker, positioned at Uluru
		const marker = new AdvancedMarkerView({
			map: map,
			position: position,
			title: 'Uluru',
		});
	},

	formatDistance(distance) {
		return `${Number(distance).toFixed(2)} km`;
	},

	close() {
		this.location = '';
		this.active_store = '';
		this.shops = [];
	},

	showMore() {
		this.default_quantity += 5;
	},
});
